module.exports = __webpack_public_path__ + "static/media/reflective-listening-large@2x.f522c02e.png";